(function ($) {
    $(() => {
        $(".numeric-input").on("input", function () {
            var inputValue = $(this).val();

            if (inputValue.length > 3) {
                $(this).val(inputValue.slice(0, 3));
            }
        });

        $('.js-delete-houses-filter').on('click', function() {
            $('.js-filter-houses-form').trigger('reset');
            $('.js-filter-houses-form').trigger('submit');
        })

        $('.js-filter-houses-form').on('submit', function (e) {
            e.preventDefault();
            $('.js-filter-layer').removeClass('d-none')
            const $this = $(this);
            const formdata = $this.serializeArray();

            $.ajax({
                url: localize.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'filter_houses',
                    datas: formdata
                },
                success(data) {
                    $('.js-filter-houses-wrapper').html(data.html);
                    if (parseInt(data.all) > 9) {
                        $('.js-load-more-houses').show();
                    } else {
                        $('.js-load-more-houses').hide();
                    }
                }
            }).done(response => {
                $('.js-filter-layer').addClass('d-none')
            });
        });

        $('.js-load-more-houses').on('click', function (e) {
            e.preventDefault();
            $('.js-filter-layer').removeClass('d-none')
            const $this = $('.js-filter-houses-form');
            const formdata = $this.serializeArray();

            let post_ids = [];
            $('.card-houses').each(function (index) {
                post_ids.push($(this).data('id'));
            });

            $.ajax({
                url: localize.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'filter_houses',
                    datas: formdata,
                    post_ids
                },
                success(data) {
                    $('.js-filter-houses-wrapper').append(data.html);
                    if (parseInt(data.page) < 9) {
                        $('.js-load-more-houses').hide();
                    } else {
                        $('.js-load-more-houses').show();
                    }
                }
            }).done(response => {
                $('.js-filter-layer').addClass('d-none')
            });
        });

        function debounce(fn, threshold) {
            var timeout;
            return function debounced() {
                if (timeout) {
                    clearTimeout(timeout);
                }
                function delayed() {
                    fn();
                    timeout = null;
                }
                timeout = setTimeout(delayed, threshold || 1000);
            };
        }

        $('.js-number-input').keyup(debounce(function () {
            $('.js-filter-houses-form').trigger('submit');
        }, 1000));

        $('.js-radio-input').on('change', function () {
            $('.js-filter-houses-form').trigger('submit');
        });

        $('.js-subject-select, .js-houses-policy').on('change', function () {
            $(this).removeClass('is-invalid');
            $(this).parent().find('.form-error').text('');
        });

        /* FORM */
        $('#houses-form').submit(function (event) {
            event.preventDefault();

            const $this = $(this);

            $this.find('.form-error').text('');

            $this.find('input').removeClass('is-invalid');

            $this.find('.btn[type="submit"]').attr('disabled', true);

            const params = $this.serializeArray();
            const formData = new FormData();

            Object.keys(params).forEach(key => {
                formData.append(params[key].name, params[key].value);
            })

            formData.append('action', 'houses_form');

            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                dataType: "json",
                processData: false,
                contentType: false,
                context: this,
                data: formData,
            })
                .done(response => {
                    if (response.status === 'error') {
                        Object.entries(response.errors).forEach(([field, error]) => {
                            $(`#form-error-${field}`).text(error);
                            $(`#${field}`).addClass('is-invalid');
                        });
                    }

                    if (response.status === 'success') {
                        $this.trigger('reset');
                        $('.js-contact-success-modal').show();
                    }
                })
                .always(() => {
                    $this.find('.btn[type="submit"]').attr('disabled', false);
                });
        });

    });
})(jQuery);
